<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="3">
        <v-text-field
          label="ココナラ受注数"
          v-model="ココナラ受注数"
        >
        <template v-slot:append>
          <v-btn @click='onClickココナラ(1)'>+</v-btn>
          <v-btn @click='onClickココナラ(-1)'>-</v-btn>
        </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
          label="ランサーズ受注数"
          v-model="ランサーズ受注数"
        >
        <template v-slot:append>
          <v-btn @click='onClickランサーズ(1)'>+</v-btn>
          <v-btn @click='onClickランサーズ(-1)'>-</v-btn>
        </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" md="3">
        <v-text-field
          label="サイト受注数"
          v-model="サイト受注数"
        >
        <template v-slot:append>
          <v-btn @click='onClickサイト(1)'>+</v-btn>
          <v-btn @click='onClickサイト(-1)'>-</v-btn>
        </template>
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-textarea
          rows='10'
          label='サイト概要'
          v-model='サイト概要'
          ></v-textarea>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-textarea
          rows='10'
          label='自己紹介'
          v-model='自己紹介'
          ></v-textarea>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-textarea
          rows='10'
          label='返金について'
          v-model='返金について'
          ></v-textarea>
      </v-col>
    </v-row>
    <v-row>
      <v-col class='mb-10'>
        <v-btn block @click='onClickサイト情報保存()'>保存</v-btn>
      </v-col>
    </v-row>

    <v-snackbar
      v-model='snackbar'
      timeout='2000'
      z-index="2002"
    >
      {{snackbarLabel}}
    </v-snackbar>
  </v-container>
</template>
<script>
export default {
  data(){
    return {
      ココナラ受注数:0,
      ランサーズ受注数:0,
      サイト受注数:0,
      サイト概要:"",
      返金について:"",
      自己紹介:"",
      snackbarLabel:"",
      snackbar:false,
    }
  },

  mounted(){
    this.サイト情報取得();
  },

  methods:{
    サイト情報取得(){
      this.$emit('overlay');
      let url = '../api/api.php';
      let data = {
        func:"サイト情報取得",
        表示:"edit"
      };

      let param = {
          method : "POST",
          headers : { "Content-Type": "application/json" },
          body : JSON.stringify(data),
          }
      fetch(url,param)
      .then(response => {return response.text();})
      .then(result => {
        try {
          const jsonData = JSON.parse(result);
          return jsonData;
        }catch(e){
          return Promise.reject({body:result,type:'unparsable'})
        }
      })
      .then(result => {
        this.ココナラ受注数 = result.サイト情報row.ココナラ受注数;
        this.ランサーズ受注数 = result.サイト情報row.ランサーズ受注数;
        this.サイト受注数 = result.サイト情報row.サイト受注数;
        this.サイト概要 = result.サイト情報row.サイト概要;
        this.返金について = result.サイト情報row.返金について;
        this.自己紹介 = result.サイト情報row.自己紹介;
        this.$emit('overlay');
      })
      .catch(error =>{
        alert('取得できませんでした。\n\n'+error.body);
        console.log(error)
        this.$emit('overlay');
      })
    },

    onClickサイト情報保存(){
      this.$emit('overlay');
      let url = '../api/api.php';
      let data = {
        func:"サイト情報保存",
        ココナラ受注数:this.ココナラ受注数,
        ランサーズ受注数:this.ランサーズ受注数,
        サイト受注数:this.サイト受注数,
        サイト概要:this.サイト概要,
        返金について:this.返金について,
        自己紹介:this.自己紹介,
      };
      let param = {
        method : "POST",
        headers : { "Content-Type": "application/json" },
        body : JSON.stringify(data),
        }
      fetch(url,param)
      .then(response => {return response.text();})
      .then(result => {
        try {
          const jsonData = JSON.parse(result);
          return jsonData;
        }catch(e){
          return Promise.reject({body:result,type:'unparsable'})
        }
      })
      .then(result => {
        console.log(result)
        this.snackbar = true;
        this.snackbarLabel = '保存しました'
        this.$emit('overlay');
      })
      .catch(error =>{
        alert('保存できませんでした。\n\n'+error.body);
        console.log(error)
        this.$emit('overlay');
      })
    },

    onClickココナラ(val){
      this.ココナラ受注数 = Number(this.ココナラ受注数) + Number(val)
    },

    onClickランサーズ(val){
      this.ランサーズ受注数 = Number(this.ランサーズ受注数) + Number(val)
    },

    onClickサイト(val){
      this.サイト受注数 = Number(this.サイト受注数) + Number(val)
    },
  }
}
</script>
